import {createSlice , createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  sellerInfo: null,
  products: [],
  orders: [],
  loading: false,
  error: null,
};

// fetch seller information 
export const fetchSellerInfo = createAsyncThunk("seller/fetchSellerInfo", async(sellerId)=>{
    const res = await axios.get(`/api/seller/${sellerId}`);
    return res.data;
});


// fetch seller products 
export const fetchSellerProducts  = createAsyncThunk("seller/fetchSellerProducts", async(sellerId)=>{
    const res = await axios.get(`/api/seller/${sellerId}/products`) ;
    return res.data;
});

// Add Products 

export const addSellerProduct = createAsyncThunk("seller/addSellerProduct", async(productData)=>{
    const res = await axios.post(`/api/seller/product`, productData);
    return res.data;
});

export const deleteProducts = createAsyncThunk("seller/deleteSellerProduct", async(productId)=>{
    const res = await axios.delete(`/api/seller/product/${productId}`);
    return res.data;
});

const sellerSlice = createSlice({
  name: "seller",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSellerInfo.pending, (state)=>{
        state.loading = true;
    }).addCase(fetchSellerInfo.fulfilled,(state,action)=>{
        state.loading=false;
        state.sellerInfo = action.payload;
    }).addCase(fetchSellerInfo.rejected , (state) =>{
        // fixed: use statements instead of comma expression to satisfy eslint
        state.loading = false;
        state.error = "failed to fetch seller information";
    })
    // fetch products 
    .addCase(fetchSellerProducts.pending, (state)=>{
        state.loading = true;
    }).addCase(fetchSellerProducts.fulfilled,(state,action)=>{
        state.loading  = false;
        state.products = action.payload;
    })
    // add products
    .addCase(addSellerProduct.fulfilled, (state,action)=>{
        state.products.push(action.payload);
    })
    //delete products
    .addCase(deleteProducts.fulfilled , (state,action)=>{
        state.products = state.products.filter((p)=> p._id !== action.payload);
    })
  }
});


export default sellerSlice.reducer;